<template>
  <el-dialog
    :visible.sync="visible"
    class="comp-container"
    custom-class="roster-component-comfirm-remove-dialog"
    :append-to-body="true"
  >
    <span class="tips"
      >是否确认将‘{{ studentInfo.nickname }}’同学移出课堂？</span
    >
    <el-checkbox v-model="isNeverJoinAgain">
      不允许该学生再次加入该课堂
    </el-checkbox>
    <div class="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="onConfirmRemove"> 确定 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { removeUser } from "@saas/server-api/src/live-sdk";
import screenShare from "../mixins/screen-share";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  mixins: [screenShare],
  props: {
    studentInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      isNeverJoinAgain: false,
    };
  },
  computed: {
    ...mapState("live", ["imService", "roomInfo"]),
  },
  watch: {},
  methods: {
    onConfirmRemove() {
      this.visible = false;
      if (this.isNeverJoinAgain) {
        this.removeUser().then((res) => {
          if (res.code === 1) {
            this.imService.sendMGLiveRoomCustomMsg({
              cmdId: 2,
              data: {
                type: "removeStudent",
                data: {
                  userId: this.studentInfo.user_id,
                },
              },
            });
            this.$emit("moveOutSuccess", this.isNeverJoinAgain);
            EventBus.$emit("move-out-success", {
              userId: this.studentInfo.user_id,
              isNeverJoinAgain: this.isNeverJoinAgain,
            });
            EventBus.$emit("removeStudent", {
              userId: this.studentInfo.user_id,
              isNeverJoinAgain: this.isNeverJoinAgain,
            });
          } else {
            this.$darkMessage.error(res.message);
          }
        });
      } else {
        this.$emit("moveOutSuccess", this.isNeverJoinAgain);
        EventBus.$emit("move-out-success", {
          userId: this.studentInfo.user_id,
          isNeverJoinAgain: this.isNeverJoinAgain,
        });
        EventBus.$emit("removeStudent", {
          userId: this.studentInfo.user_id,
          isNeverJoinAgain: this.isNeverJoinAgain,
        });
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "removeStudent",
            data: {
              userId: this.studentInfo.user_id,
            },
          },
        });
      }
    },
    // 移除用户
    removeUser() {
      return removeUser({
        user_id: this.studentInfo.user_id,
        room_id: this.roomInfo.id,
        is_permanent_remove: this.isNeverJoinAgain ? 1 : 0, // 1 永久移除
        action: 0, // 0 移除，1 移入
      });
    },
    open() {
      this.visible = true;
      this.isNeverJoinAgain = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .roster-component-comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 !important;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;
      display: flex;
      flex-direction: column;
      text-align: center;
      .tips {
        line-height: 20px;
        color: #f7f8fa;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #f7f8fa !important;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
